module.exports = __webpack_public_path__ + "img/Villa.c063a7a9.svg";